<template>
  <div class="row">
    <div class="col-lg-6 offset-lg-3 col-12 text-center p-0">
      <div>
        <template v-if="isBetweenPromotionDays">
          <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/q_chang/beneat_qchang.png" alt=""
               class="card-img-top" />
        </template>
        <template v-else>
          <img src="/static/img/qChang/q_chang_combination_Aircon2.png" alt=""
               class="card-img-top" />
        </template>
        <!-- <template v-else>
          <img src="/static/img/qChang/q_chang_service_resized_2023_02_16.jpg"
               class="img-fluid" />
        </template> -->
      </div>
      <section class="px-3">
        <div class="py-4 title">
          BeNeat ร่วมกับ Q-CHANG (คิวช่าง)
        </div>
        <div>
          ศูนย์รวมช่างคุณภาพและบริการดูแลบ้านครบวงจร<br>
          เพื่อเพิ่มความสะดวกสบายให้กับคุณลูกค้า<br>
          โดยคุณลูกค้าสามารถจองบริการช่างล้างแอร์ และล้างเครื่องซักผ้า<br>
          จากคิวช่างได้โดยตรง ผ่าน Application BeNeat
        </div>
        <div class="pt-3">
          บริการนี้อยู่ระหว่างการทดสอบให้บริการ<br>
          คุณลูกค้าสามารถกดปุ่มด้านล่างเพื่อเข้าสู่ระบบคิวช่าง<br>
          และทำการจองบริการต่าง ๆ ของคิวช่างได้โดยตรง
        </div>
        <div class="py-4">
          <router-link to="/q-chang/2" class="btn btn-info btn-lg">
            เข้าสู่ระบบ "คิวช่าง"
          </router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  computed: {
    isBetweenPromotionDays () {
      const dateNow = moment(new Date())
      const startDate = moment('01/07/2024 00:00:00', 'DD/MM/YYYY HH:mm:ss')
      const endDate = moment('31/12/2024 23:59:59', 'DD/MM/YYYY HH:mm:ss')
      return dateNow.isBetween(startDate, endDate)
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 1.25rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/qChang/Step1.vue